import instance from "../utils/apiUtils";

export const addGroup = async (group) => {
  try {
    const response = await instance.post("/api/groups", group);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getAllGroups = async (page = 0) => {
  try {
    const response = await instance.get(`api/groups?size=10&page=${page}`);
    const totalCount = parseInt(response.headers["x-total-count"]);
    const data = response.data;

    return { totalCount, data };
  } catch (error) {
    throw error.response.data;
  }
};

export const updateGroup = async (group) => {
  try {
    const response = await instance.put(`api/groups/${group.id}`, group);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getGroupById = async (id) => {
  try {
    const response = await instance.get(`api/groups/${id}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getGroupByUser = async (userId) => {
  try {
    const response = await instance.get(`api/group-users/user/${userId}`);
    return response.data[0];
  } catch (error) {
    throw error.response.data;
  }
};

export const deleteGroup = async (id) => {
  try {
    const response = await instance.delete(`api/groups/${id}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const addGroupToUser = async (user, group) => {
  try {
    const response = await instance.post("/api/group-users", { user, group });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
